module.exports = __webpack_public_path__ + "components/flag/static/square/eh-9500a99f4769e5bafead9745443c84dc.svg";